// スクロールの閾値（この値以上スクロールしたらクラスを追加）
const SCROLL_THRESHOLD = 100;

function HandleScroll() {
  // console.log('HandleScroll');
  const body = document.body;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > SCROLL_THRESHOLD) {
    if (!body.classList.contains('is-scrolled')) {
      body.classList.add('is-scrolled');
    }
  } else {
    body.classList.remove('is-scrolled');
  }
}

// スクロールイベントリスナーを登録
window.addEventListener('scroll', HandleScroll);

// 初期読み込み時にもチェック
HandleScroll();
